const mutations = {
  setUser(state, payload) {
    state.user = payload;
  },
  setShowLogin(state, payload) {
    state.isLoginShow = payload;
  },
  setShowRegister(state, payload) {
    state.isRegisterShow = payload;
  },
};

export default mutations;
